import { Link } from "react-router-dom";
import type { Guide } from "@/types/content";

interface GuideCardProps {
  guide: Guide;
}

export default function GuideCard({ guide }: GuideCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-secondary-300">
      <Link to={`/guides/${guide.id}`} className="flex h-full flex-col cursor-pointer">
        <div className="h-40 w-full overflow-hidden bg-background-100">
          <img
            src={guide.cover}
            alt={`${guide.title} 配图`}
            title={`${guide.title} - 维权指南`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col p-5">
          <div className="flex items-center gap-2 font-label text-xs text-foreground-500">
            <span className="rounded-full bg-secondary-50 px-2.5 py-1 text-secondary-800">{guide.category}</span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" />
              {guide.readMinutes} 分钟读完
            </span>
          </div>
          <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
            {guide.title}
          </h3>
          <p className="mt-2 line-clamp-2 font-body text-sm leading-relaxed text-foreground-600">{guide.summary}</p>
          <span className="mt-4 inline-flex items-center gap-1 font-label text-xs font-medium text-primary-700">
            阅读全文
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
          </span>
        </div>
      </Link>
    </article>
  );
}